import React, { useMemo, useCallback, SyntheticEvent } from 'react';
import _debounce from 'lodash/debounce';
import { Input } from 'components';

interface Props {
  onChange: (text: string) => any;
}

export const SearchInput = ({ onChange }: Props) => {
  const debouncedChange = useMemo(
    () => _debounce(onChange, 200, { leading: true }),
    [onChange],
  );
  const handleChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      debouncedChange(e.currentTarget.value);
    },
    [debouncedChange],
  );

  return (
    <Input
      small
      noMargin
      insideRightIcon="ri-search-line"
      onChange={handleChange}
    />
  );
};
